// src/utils/videoUtils.ts

import { auth, db } from "../firebase";
import {
  getDoc,
  doc,
  addDoc,
  collection,
  serverTimestamp,
  DocumentReference,
} from "firebase/firestore";
import { getUserVipStatus } from "./vipUtils";
import { fetchSignedCookie as fetchSignedCookieApi } from "./api"; // ←相対パスは環境に合わせて調整
export const fetchSignedCookie = fetchSignedCookieApi;

interface VipStatus {
  rank: string;
  points: number;
  gachaCount: number;
  totalSpent: number;
  [key: string]: any;
}

interface RegisterVideoParams {
  title: string;
  key: string;
  fileType: string;
  category?: string;
  tags?: string[];
}

/**
 * CloudFront署名付きCookieを発行し、document.cookieにセットする
 * @param m3u8Key m3u8ファイルへのS3キー（例: converted/xxxx/filename/playlist.m3u8）
 */
export const setCloudFrontSignedCookies = async (m3u8Key: string): Promise<void> => {
  if (!m3u8Key || typeof m3u8Key !== "string") {
    throw new Error("m3u8Key が未指定または不正です");
  }

  try {
    // fetchSignedCookieで取得
    const { cookies } = await fetchSignedCookie(m3u8Key);
    if (!cookies) throw new Error("Cookieが空です");
    // 各Cookieをdocument.cookieにセット
    Object.entries(cookies).forEach(([name, value]) => {
      // Cookie属性（Secure, SameSite, Domain, Path）は必要に応じて調整
      document.cookie = `${name}=${value}; Path=/; Secure; SameSite=None; Domain=.toa-fans.shop`;
    });
  } catch (err) {
    console.error("🔥 署名付きCookie取得エラー:", err);
    throw err;
  }
};

/**
 * VIPユーザー判定
 */
export const isVipUser = async (): Promise<boolean> => {
  const user = auth.currentUser;
  if (!user) return false;
  const vipStatus = (await getUserVipStatus(user.uid)) as VipStatus;
  return vipStatus.rank === "VIP12";
};

/**
 * 購入済み判定
 */
export const hasPurchasedVideo = async (videoId: string): Promise<boolean> => {
  const user = auth.currentUser;
  if (!user) return false;
  const snap = await getDoc(doc(db, "purchases", `${user.uid}_${videoId}`));
  return snap.exists();
};

/**
 * Firestoreへ動画を登録
 */
export const registerUploadedVideo = async ({
  title,
  key,
  fileType,
  category = "その他",
  tags = [],
}: RegisterVideoParams): Promise<DocumentReference> => {
  const user = auth.currentUser;
  if (!user) throw new Error("ログインが必要です");

  const videosRef = collection(db, "videos");
  return await addDoc(videosRef, {
    title,
    key,
    fileType,
    category,
    tags,
    userId: user.uid,
    createdAt: serverTimestamp(),
    status: "public",
  });
};
